import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ContactUsSubject } from '../contact_us_subject-types';

/**
 * This services provides form for contact us subject editors
 */
@Injectable({
  providedIn: 'root'
})
export class ContactUsSubjectFormsService {

  constructor(private formBuilder: UntypedFormBuilder) { }

  /**
   * Prepare a form group from a subject
   * Currently the form used for the inline editor and the dialog are the same definition
   * hence they use this same method
   */
  setupContactUsSubjectForm(subject: ContactUsSubject) {
    const form = this.formBuilder.group(
      {
        subjectName: new UntypedFormControl(subject.Subject, [Validators.required]),
        notifyType: new UntypedFormControl(subject.NotifyType, [Validators.required]),
        emails: new UntypedFormControl(subject.Emails, [Validators.required, this.emailArrayValidator() ])
      })
    return form;
  }

  /**
   * Maps the values from a form to the subject
   * @param form The form to map to subject
   * @param subject The subject whose values will be mapped from the form
   */
  mapFormToSubject(form: UntypedFormGroup, subject: ContactUsSubject ) : void {
    subject.Emails = form.controls['emails'].value;
    subject.NotifyType = form.controls['notifyType'].value;
    subject.Subject = form.controls['subjectName'].value;
  }

  /**
   * https://tools.ietf.org/html/rfc3696#page-5
   */
  private isValidEmail( email: string) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
  }

  emailArrayValidator() : ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null =>  
      {
        if ( Array.isArray(control.value)) {
          return control.value.every( s=> this.isValidEmail(s)) ? null : { invalidEmail: control.value }
        }
      }
  }
  

}
